import { createStyles, Theme } from '@material-ui/core';

const styles = ({ spacing }: Theme) => createStyles({
  root: {
    marginTop: spacing(8),
    maxWidth: spacing(100),
  },
  title: {
    marginTop: spacing(2),
  },
  link: {
    marginTop: spacing(3),
    display: 'flex',
    width: 'fit-content',
    '& svg': {
      transform: 'rotate(180deg)',
    },
  },
});

export default styles;
